import * as actionTypes from './actionTypes';
import { 
    getImgBboxDataUrlApi
 } from '../../apiUtils/api';

export const initBboxDataLoading=()=>{
    return { type: actionTypes.INIT_BBOX_IMAGE_DATA };
}

export const grabBboxData=(taskId)=>{
    return dispatch => getImgBboxDataUrlApi(taskId).then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.GRAB_BBOX_IMAGE_DATA_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GRAB_BBOX_IMAGE_DATA, imgData: data });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.GRAB_BBOX_IMAGE_DATA_ERROR, error: err});
    })
}


// WEBPACK FOOTER //
// ./src/redux/boundingBox/actions.js